import queryString from 'querystring';

class Fetcher {
    constructor() {
        this.baseUrl = '/search/json';
    }

    getResults(query, start = 0, amount = 10) {
        const params = {
            q: query,
            o: start,
            a: amount,

        };

        return fetch(`${this.baseUrl}?${queryString.stringify(params)}`, { method: 'GET' })
            .then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                throw new Error();
            })
            .catch(() => null);
    }
}

export default Fetcher;
